export const API = 'https://yojabe.ru/api';
export const SUGGEST = "e2c39101-7fbe-4f39-b763-386a121bfddb"
export const GEOCODE_API_KEY = "3fe4a59e-51c2-4bd1-b8b9-4529734cd670"
export const OPENAI_API_KEY = "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"